import { Breadcrumb } from 'components/breadcrumb'
import { PrivateRoute } from 'components/route'
import { useFlags } from 'config/useFlagsContext'
import { useRouteMatch } from 'react-router'
import { Switch } from 'react-router-dom'
import Permissions from 'types/Permissions'
import { AtendimentoRetificacaoView } from 'view/atendimentos/detail/AtendimentoRetificacaoView'
import { AtendimentoView } from 'view/atendimentos/detail/AtendimentoView'
import { grupoCboAtendimento } from 'view/cidadao/authorization/acessos'

import { ListaRegistroTardioView } from './ListaRegistroTardioView'

export const REGISTRO_TARDIO_PATH = '/registroTardio'

export function RegistroTardioRootView() {
  const {
    PILOTO_RETIFICACAO_ATENDIMENTO_PROCEDIMENTOS_ENABLED,
    RETIFICACAO_ATENDIMENTO_VACINACAO_ENABLED,
    RETIFICACAO_ATENDIMENTO_INDIVIDUAL_ENABLED,
  } = useFlags()
  const match = useRouteMatch()

  const isRetificacaoEnabled =
    PILOTO_RETIFICACAO_ATENDIMENTO_PROCEDIMENTOS_ENABLED ||
    RETIFICACAO_ATENDIMENTO_VACINACAO_ENABLED ||
    RETIFICACAO_ATENDIMENTO_INDIVIDUAL_ENABLED

  return (
    <>
      <Breadcrumb title='Registro tardio de atendimento' />
      <Switch>
        {isRetificacaoEnabled && (
          <PrivateRoute
            path={`${match.url}/:atendimentoProfissionalId(\\d+)/retificar`}
            component={AtendimentoRetificacaoView}
            permission={Permissions.visualizarListaDeAtendimento.registrarAtendimento}
            cbos={grupoCboAtendimento}
          />
        )}
        <PrivateRoute
          path={`${match.url}/:atendimentoId(\\d+)`}
          component={AtendimentoView}
          permission={Permissions.visualizarListaDeAtendimento.registrarAtendimento}
          cbos={grupoCboAtendimento}
        />
        <PrivateRoute
          component={ListaRegistroTardioView}
          permission={Permissions.visualizarListaDeAtendimento}
          acceptEstagio={false}
        />
      </Switch>
    </>
  )
}

export const urlFromRegistroTardio = (url: string): boolean => url.includes(REGISTRO_TARDIO_PATH)
